import { p as palette } from '../base/color-DMp1DFwP.js';
import { t as typography } from '../base/typography-Bqsizo4g.js';

const breadcrumbs = {
  color: typography.color.secondary,
  spacer: palette.gray[300]
};

export { breadcrumbs as b };
//# sourceMappingURL=breadcrumb-CqtUb2OV.js.map
